function capitalize(string) {
  if (typeof string !== 'string') return '';
  const str = string.replace(/_/g, ' '); // Unterstrich mit Space ersetzen
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default capitalize;
